module.exports = __webpack_public_path__ + "img/tjfoot9.20016f43.jpg";